var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: { title: "用户", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            },
            close: function($event) {
              return _vm.resetForm("ruleForm")
            }
          }
        },
        [
          _c("div", { staticClass: "popover" }, [
            _c("div", { staticClass: "lodingItem" }, [
              _c("div", { staticClass: "lodingItem-mintitle" }, [
                _vm._v("账号")
              ]),
              _c(
                "div",
                { staticClass: "lodingItem-operationFrame" },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { autocomplete: "off", placeholder: "请输入" },
                    model: {
                      value: _vm.form.email,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "lodingItem" }, [
              _c("div", { staticClass: "lodingItem-mintitle" }, [
                _vm._v("角色")
              ]),
              _c(
                "div",
                { staticClass: "lodingItem-operationFrame" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.auth_group_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "auth_group_id", $$v)
                        },
                        expression: "form.auth_group_id"
                      }
                    },
                    _vm._l(_vm.optionsoRganization, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "lodingItem" }, [
              _c("div", { staticClass: "lodingItem-mintitle" }, [
                _vm._v("密码")
              ]),
              _c(
                "div",
                { staticClass: "lodingItem-operationFrame" },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: {
                      placeholder: "不填写即不修改",
                      autocomplete: "off"
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "lodingItem" }, [
              _c("div", { staticClass: "lodingItem-mintitle" }, [
                _vm._v("昵称")
              ]),
              _c(
                "div",
                { staticClass: "lodingItem-operationFrame" },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: {
                      placeholder: "不填写即不修改",
                      autocomplete: "off"
                    },
                    model: {
                      value: _vm.form.nickname,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nickname", $$v)
                      },
                      expression: "form.nickname"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "lodingItem" }, [
              _c("div", { staticClass: "lodingItem-mintitle" }, [
                _vm._v("上级用户")
              ]),
              _c(
                "div",
                { staticClass: "lodingItem-operationFrame" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.form.parent_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "parent_id", $$v)
                        },
                        expression: "form.parent_id"
                      }
                    },
                    _vm._l(_vm.allList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.nickname, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "lodingItem" }, [
              _c("div", { staticClass: "lodingItem-mintitle" }, [
                _vm._v("状态")
              ]),
              _c(
                "div",
                { staticClass: "lodingItem-operationFrame" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "1", border: "" } }, [
                        _vm._v("启用")
                      ]),
                      _c("el-radio", { attrs: { label: "0", border: "" } }, [
                        _vm._v("禁用")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.resetForm("ruleForm")
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }